import React, { useState, useEffect } from "react";
import ShowOnVisible from "components/ShowOnVisible";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import TeamVideoPlayer from "components/TeamVideoPlayer";
import VideoRecorder from "components/AttachmentSelection/VideoRecorder";
import GeneralService from "services/GeneralService";
import ButtonWithProgress from "components/ButtonWithProgress";
import { useTimelineContext } from "store/contexts/timelineContext";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import VideoEncoder from "components/AttachmentSelection/VideoEncoder";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as BinIcon } from "assets/img/icons/bin.svg";
import Button from "components/CustomButton";

var styles = {
  containerClass: {
    display: "flex",
    flexDirection: "column",
    background: "unset",
  },
  recordVideoContainer: {
    width: "100%",
    padding: "15px",
    background: "rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  responseOptions: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
  },
  cancelVideoRecorder: {
    width: "100%",
    maxWidth: "80vw",
    backgroundColor: "#1e242c",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    padding: "5px 0",
  },
  cancelIcon: {
    marginLeft: "12px",
    cursor: "pointer",
    width: "25px",
  },
  showVideoRecorder: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  binIcon: {
    cursor: "pointer",
    width: "35px",
    height: "35px",
    background: "#434343",
    fill: "white",
    borderRadius: "50%",
    padding: "5px",
    boxShadow: "0 1px 8px 0 rgb(0 0 0 / 20%), 0 4px 23px 0 rgb(0 0 0 / 19%)",
    zIndex: "2",
  },
  buttonContainer: {
    position: "absolute",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    alignItems: "center",
    bottom: "50px",
    gap: "10px",
  },
  videoSubmitedText: {
    marginBottom: "0px",
    fontSize: "18px",
    marginTop: "5px",
    fontWeight: "400",
  },
  videoSubmitText: {
    marginBottom: "18px",
    fontSize: "18px",
    marginTop: "5px",
    fontWeight: "400",
  },
  responseOptionText: {
    fontSize: "16px",
    fontWeight: 400,
    color: "white",
  },
};

export default ({ post }) => {
  const classes = styles;
  const [teamVideo, setTeamVideo] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoData, setVideoData] = useState(null);
  const [yourResponse, setYourResponse] = useState(false);
  const [selectAttachment, setSelectAttachment] = useState(false);
  const [webCamData, setWebCamData] = useState();
  const [initialVideoResponse] = useState({
    media: post?.data.media,
    user: post?.user,
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const { updatePost } = useTimelineContext();
  const [showVideoRecorderOption, setShowVideoRecorderOption] = useState(false);

  useEffect(() => {
    if (!teamVideo) {
      return;
    }

    updatePost({
      ...post,
      data: {
        ...teamVideo,
      },
    });

    // eslint-disable-next-line
  }, [teamVideo]);

  const height = post?.data?.published_at || isRecording ? "400px" : "150px";

  const onLoad = async () => {
    const response = await TeamService.getTeamVideo(post.team_id, post?.id);

    setTeamVideo(response.data.data);
  };

  const submitTeamVideo = async () => {
    setIsSubmitting(true);
    try {
      let media = null;

      const preSignedResponse = await GeneralService.getPresignedUploadURL({
        filename: videoData.name,
        mime_type: videoData.type,
        file_size: videoData.size,
        resource_type: "team",
        resource_id: post.team_id,
        resource_policy: "team.teamvideo",
      });

      const { key, url } = preSignedResponse.data.data;

      media = key;

      await GeneralService.uploadToS3(url, videoData, (progress) => {
        setUploadProgress(progress);
      });

      await TeamService.postTeamVideoResponse(
        post.team_id,
        post?.data?.id,
        media
      );

      if (post?.data?.responses_count + 1 === post?.data?.max_responses_count) {
        await onLoad();
      }

      const postCopy = { ...post };

      postCopy.data.responses_count += 1;
      updatePost(postCopy);

      setYourResponse(true);
      setVideoData(null);
      if (webCamData) {
        webCamData.dispose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onAttachmentSelected = (data) => {
    setVideoData(data);
    setSelectAttachment(true);
  };

  const clearAttachment = () => {
    setSelectAttachment(false);
    setVideoData(null);
    setShowVideoRecorderOption(false);
  };

  const cancelRecordingData = () => {
    setIsRecording(false);
    if (videoData) {
      setVideoData(null);
    }
    if (webCamData) {
      webCamData.dispose();
    }
  };
  return (
    <ShowOnVisible
      height={height}
      maxHeight="700px"
      containerClass={"containerClass"}
    >
      {!post?.data?.published_at && (
        <>
          {!post?.data?.is_responded && (
            <>
              {!Boolean(isRecording) && !Boolean(selectAttachment) && (
                <>
                  <div style={classes.recordVideoContainer}>
                    <p style={classes.videoSubmitText}>
                      {post?.data?.responses_count} of{" "}
                      {post?.data?.max_responses_count} Videos submitted
                    </p>
                    {!showVideoRecorderOption && (
                      <Button
                        buttonStyle={{
                          width: "200px",
                        }}
                        onClick={() =>
                          setShowVideoRecorderOption(!showVideoRecorderOption)
                        }
                        type="button"
                        buttonClass={"grad_btn join-btn"}
                        name="Submit Your Response"
                      />
                    )}
                    {showVideoRecorderOption && (
                      <div style={{ marginBottom: "5px" }}>
                        <div style={classes.responseOptions}>
                          <AttachmentSelection
                            videoSpanClass={null}
                            videoClass="responseOption"
                            videoTextClass="responseCaptureOption"
                            attachmentTextClass="responseCaptureOption"
                            videoText={
                              <div style={classes.responseOptionText}>
                                Record a Video
                              </div>
                            }
                            attachmentText={
                              <div style={classes.responseOptionText}>
                                Upload a Video
                              </div>
                            }
                            attachmentClass="responseOption"
                            videocamIconColor={"white"}
                            classAttatchment={"selectAttachmentIcon"}
                            attachmentIconColor={"white"}
                            onChange={onAttachmentSelected}
                            showSelectors={false}
                            accepted={[".mp4"]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {!selectAttachment && (
                    <TeamVideoPlayer
                      post={post}
                      videoResponses={[initialVideoResponse]}
                      postPublished={post.data.published}
                    />
                  )}
                </>
              )}
              {Boolean(selectAttachment) && !yourResponse && (
                <div style={{ width: "100%" }}>
                  <div style={classes.buttonContainer}>
                    {videoData && (
                      <BinIcon
                        onClick={clearAttachment}
                        style={classes.binIcon}
                      />
                    )}
                    <ButtonWithProgress
                      isSubmitting={isSubmitting}
                      progress={uploadProgress}
                      isValid={videoData}
                      buttonWithProgressClass={"grad_btn join-btn"}
                      onClick={submitTeamVideo}
                      style={{
                        width: "170px",
                        zIndex: "100",
                        top: "0",
                        right: "3px",
                      }}
                      initialText="Submit Response"
                    />
                  </div>
                  <AttachmentPreview
                    removePreviewAttachment={"removeAttachmentIcon"}
                    commentAttachmentPreview={"teamAttachmentPreview"}
                    attachment={videoData}
                    clearAttachment={clearAttachment}
                  />
                </div>
              )}
              {Boolean(isRecording) && !yourResponse && (
                <div style={classes.showVideoRecorder}>
                  {videoData && (
                    <ButtonWithProgress
                      isSubmitting={isSubmitting}
                      progress={uploadProgress}
                      isValid={videoData}
                      buttonWithProgressClass={"grad_btn join-btn"}
                      onClick={submitTeamVideo}
                      style={{
                        position: "absolute",
                        zIndex: "100",
                        top: "0",
                        right: "3px",
                      }}
                      initialText="Submit Response"
                    />
                  )}
                  <div style={classes.cancelVideoRecorder}>
                    <CancelIcon
                      style={classes.cancelIcon}
                      onClick={cancelRecordingData}
                    />
                  </div>
                  <VideoEncoder loading={loading} />
                  <VideoRecorder
                    setLoading={setLoading}
                    height="400px"
                    setWebCamData={setWebCamData}
                    width={-1}
                    disposeAfterRecording={false}
                    onChange={(data) => setVideoData(data)}
                    startRecord={() => setVideoData(null)}
                  />
                </div>
              )}
            </>
          )}
          {(Boolean(post?.data?.is_responded) || yourResponse) && (
            <>
              <div style={classes.recordVideoContainer}>
                <p style={classes.videoSubmitedText}>
                  {post?.data?.responses_count} of{" "}
                  {post?.data?.max_responses_count} Videos submitted
                </p>
              </div>
              <TeamVideoPlayer
                post={post}
                videoResponses={[initialVideoResponse]}
                postPublished={post.data.published}
              />
            </>
          )}
        </>
      )}
      {post?.data?.published_at && (
        <>
          <img
            style={{ display: "none" }}
            src="dasd"
            alt="dummy"
            onError={onLoad}
          ></img>
          {!teamVideo && <Loader />}
          {teamVideo && (
            <TeamVideoPlayer
              post={post}
              videoResponses={teamVideo?.team_video_responses}
              postPublished={post.data.published}
            />
          )}
        </>
      )}
    </ShowOnVisible>
  );
};
